module.exports = __webpack_public_path__ + "img/ysgj_012@2x.d3be1803.png";